class AppConfig {
    static ApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
    static PfqBaseUrl = import.meta.env.VITE_PFQ_BASE_URL;
    static CasePeerBaseUrl = import.meta.env.VITE_CASE_PEER_BASE_URL;
    static FeBaseUrl = import.meta.env.VITE_FE_BASE_URL;
    static DropboxAppKey = import.meta.env.VITE_DROPBOX_APP_KEY;
    static OneDriveClientId = import.meta.env.VITE_ONEDRIVE_CLIENT_ID;
    static CertifiedLifecareEnabled = import.meta.env.VITE_IS_CERTIFIED_LIFE_CARE_PLAN_BUTTON_VISIBLE;
}

export default AppConfig;